<template>
  <div class="bad-words-indicator">
    <v-tooltip bottom>
      <template v-slot:activator="{ on, attrs }">
        <div
          class="indicator-square"
          :class="indicatorStatus"
          v-bind="attrs"
          v-on="on"
        ></div>
      </template>
      <span>{{ indicatorTooltip }}</span>
    </v-tooltip>
  </div>
</template>

<script>
export default {
  name: 'BadWords',
  props: {
    description: {
      type: String,
      default: ''
    },
    hours: {
      type: [String, Number],
      default: 0
    },
    badWords: {
      type: Array,
      default: () => []
    }
  },
  computed: {
    indicatorStatus () {
      if (!this.description || !this.hours) return 'gray'

      const hasBadWord = this.checkForBadWords(this.description)
      if (hasBadWord) return 'red'

      const lettersPerHour = this.calculateLettersPerHour(this.description, this.hours)
      return lettersPerHour >= 15 ? 'green' : 'yellow'
    },
    indicatorTooltip () {
      return this.getDescriptionIndicatorTooltip(this.description, this.hours)
    }
  },
  methods: {
    checkForBadWords (description) {
      if (!description || !this.badWords.length) return false
      const lowerDescription = description.toLowerCase()
      return this.badWords.some(word => {
        const regex = new RegExp(`\\b${word.Word.toLowerCase()}\\b`, 'i')
        return regex.test(lowerDescription)
      })
    },
    convertTimeToHours (timeString) {
      if (!timeString) return 0
      if (typeof timeString === 'number') return timeString

      if (timeString.includes(':')) {
        const [hours, minutes] = timeString.split(':').map(Number)
        return hours + (minutes / 60)
      }
      return parseFloat(timeString) || 0
    },
    calculateLettersPerHour (description, hours) {
      if (!description || !hours) return 0
      const letterCount = description.replace(/[^a-zA-Z]/g, '').length
      const numericHours = typeof hours === 'string' ? this.convertTimeToHours(hours) : hours
      return numericHours > 0 ? letterCount / numericHours : 0
    },
    getDescriptionIndicatorTooltip (description, hours) {
      if (!description || !hours) {
        return 'Indicator will appear when description and reported hours are entered'
      }

      const hasBadWord = this.checkForBadWords(description)
      if (hasBadWord) return 'Description contains discouraged words'

      const lettersPerHour = this.calculateLettersPerHour(description, hours)
      if (lettersPerHour >= 15) {
        return 'Description quality is good'
      } else {
        return 'Consider adding more details to your description'
      }
    }
  }
}
</script>

<style lang="scss" scoped>
.bad-words-indicator {
  display: inline-flex;
  align-items: center;
  .indicator-square {
    width: 16px;
    height: 16px;
    border: 1px solid #ccc;
    border-radius: 2px;
    z-index: 2;
    flex-shrink: 0;

    &.green { background-color: #4CAF50; }
    &.yellow { background-color: #FFEB3B; }
    &.red { background-color: #F44336; }
    &.gray { background-color: #9E9E9E; }
  }
}
</style>
